import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mvpApi } from '../services/api';
import LanguageSwitch from '../components/LanguageSwitch';
import './ReferPage.css';

export default function ReferPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [referralCode, setReferralCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copyFeedback, setCopyFeedback] = useState(false);

  useEffect(() => {
    let cancelled = false;
    mvpApi
      .getMe()
      .then((res) => {
        const data = res.data?.user || res.data;
        if (!cancelled && data?.referral_code) setReferralCode(data.referral_code);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const handleCopyCode = () => {
    if (!referralCode) return;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(referralCode).then(() => {
        setCopyFeedback(true);
        setTimeout(() => setCopyFeedback(false), 2000);
      });
    }
  };

  return (
    <div className="mvp-refer-page">
      <header className="mvp-refer-header">
        <button type="button" className="mvp-refer-back" onClick={() => navigate('/dashboard')}>
          ← {t('back')}
        </button>
        <h1 className="mvp-refer-title">{t('refer.title')}</h1>
        <p className="mvp-refer-desc">{t('refer.desc')}</p>
        <LanguageSwitch />
      </header>
      <main className="mvp-refer-main">
        <section className="mvp-refer-section">
          <h2>{t('refer.yourCode')}</h2>
          {loading ? (
            <p>{t('loading')}</p>
          ) : referralCode ? (
            <div className="mvp-refer-code-wrap">
              <span className="mvp-refer-code">{referralCode}</span>
              <button type="button" className="mvp-refer-copy" onClick={handleCopyCode}>
                {copyFeedback ? t('refer.copied') : t('refer.copy')}
              </button>
            </div>
          ) : (
            <p className="mvp-refer-muted">Referral code will appear here.</p>
          )}
        </section>
        <button type="button" className="mvp-refer-link" onClick={() => navigate('/referrals')}>
          {t('refer.whoUsed')}
        </button>
      </main>
    </div>
  );
}
